import type { DriveStep } from 'driver.js';

const at = (id: string) => `[data-tour="${id}"]`;

/** "Tour this page" for Integrations (/integrations). Anchors live in IntegrationsPage.tsx. */
export function getIntegrationsTourSteps(): DriveStep[] {
  return [
    {
      popover: {
        title: 'Connect your tools',
        description:
          'Integrations connect outside services to your site — most importantly your MLS, so your ' +
          'real listings show up automatically.',
      },
    },
    {
      element: at('integrations-add'),
      popover: {
        title: 'Add an integration',
        description:
          'Click here to add an API integration. For your MLS, use the MLS wizard instead — it asks which MLS you belong to and works out the rest.',
        side: 'bottom',
        align: 'end',
      },
    },
    {
      element: at('integrations-list'),
      popover: {
        title: 'Where they appear',
        description:
          'Once connected, your integrations show up here — each with a status dot (green = working, ' +
          'red = needs attention) so you can see at a glance that your data is flowing.',
        side: 'top',
        align: 'center',
      },
    },
  ];
}
